<template>
  <stage-card-info-list class="relevance-distribution">
    <template #header>
      Remaining Relevant
      <div class="header-caption">
        Likelihood of relevance for remaining unscreened references.
      </div>
    </template>
    <template #content>
      <template v-if="hasData">
        <confidence-distribution
          :data="confidenceData"
          :remaining-screening-count="remainingCount"
        />
        <div class="legend-container">
          <div class="legend">
            <div class="legend-box not-relevant"></div>
            Likely Not Relevant
          </div>
          <div class="legend">
            <div class="legend-box maybe-relevant"></div>
            Maybe Relevant
          </div>
          <div class="legend">
            <div class="legend-box relevant"></div>
            Likely Relevant
          </div>
        </div>
      </template>
      <div v-else class="text-body-2">
        Check back here for data after the model has completed
        training.
      </div>
    </template>
  </stage-card-info-list>
</template>

<script>
import StageCardInfoList from '@/components/DashboardTab/StageCardInfoList';
import ConfidenceDistribution from '@/components/ReviewSummary/ConfidenceDistribution';
import { Review } from '@/models';

export default {
  name: 'RelevanceDistribution',
  components: {
    StageCardInfoList,
    ConfidenceDistribution,
  },
  props: {
    review: {
      type: Review,
      required: true,
    },
  },
  computed: {
    hasData() {
      const {
        screeningProgressSummary,
        remainingRelevantAnalysis,
      } = this.review;
      return (
        screeningProgressSummary.totalRemaining() > 0 &&
        remainingRelevantAnalysis
      );
    },
    remainingCount() {
      const { screeningProgressSummary } = this.review;
      return screeningProgressSummary.totalRemaining();
    },
    confidenceData() {
      const { remainingRelevantAnalysis } = this.review;
      const { total } = remainingRelevantAnalysis ?? {};
      if (!total) return [];
      return total.confidenceDistribution;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/main.sass';

.relevance-distribution {
  .header-caption {
    @extend .pt-1, .caption;
    color: map-get($grey, 'base');
  }

  .legend-container {
    display: flex;
    gap: 12px;

    .legend {
      display: flex;
      align-items: center;
      gap: 4px;

      font-size: 10px;
      font-weight: 500;
      color: black;
    }

    .legend-box {
      width: 16px;
      height: 16px;
      border-radius: 2px;

      &.relevant {
        background-color: var(--v-success-base);
      }

      &.maybe-relevant {
        background-color: var(--v-warning-base);
      }

      &.not-relevant {
        background-color: var(--v-error-base);
      }
    }
  }
}
</style>
